import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityBadges = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      label: 'SSL Encrypted',
      description: '256-bit encryption'
    },
    {
      icon: 'Lock',
      label: 'SOC 2 Compliant',
      description: 'Enterprise security'
    },
    {
      icon: 'CheckCircle',
      label: 'GDPR Ready',
      description: 'Data protection'
    }
  ];

  return (
    <div className="flex flex-col sm:flex-row items-center justify-center space-y-4 sm:space-y-0 sm:space-x-8 py-6">
      {securityFeatures?.map((feature, index) => (
        <div key={index} className="flex items-center space-x-2 text-muted-foreground">
          <Icon name={feature?.icon} size={16} />
          <div className="text-center sm:text-left">
            <p className="text-xs font-medium">{feature?.label}</p>
            <p className="text-xs opacity-75">{feature?.description}</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default SecurityBadges;